import React, { FC, useContext, useEffect, useState } from 'react'
import * as pageUtils from './__index.utils'
import { AppStateContext } from '@components/layouts/DynamicLayout'
import { joinClasses } from '@utils/styles'
import { Request, RequestConsent } from '@services/models'
import DossierViewer from './DossierViewer'
import { MODAL } from '@pages/auth/requests/__[id].utils'
import {
	DOCUMENT_ENVOYE_FORM,
	DOSSIER_FORM,
	PROGRESS_REPORT
} from './__index.utils'
import { permisUrbIcon } from '@images/icons'
import { RepereIntegrationRepository } from '@services/repositories/_miscellaneous.repository'
import RequestLoader from '../requestLoader'

type propsType = {
	request: Request
	isModalOpen: string
	consentList: RequestConsent[]
	consentClassWrapper: string
	onAddNewConsent: (consent: RequestConsent) => void
	onCloseModal: () => void
	onToggleModal: (value: string) => void
	onInformationAdded: (consentId: any) => void
}

type stateType = {
	isPaymentSuccessful?: boolean
	code?: string
	hasInvoice?: boolean
}

const TNUrbanRequestDetails: FC<propsType> = ({
	request: requestInfo,
	consentList,
	consentClassWrapper,
	onCloseModal,
	isModalOpen,
	onInformationAdded,
	onAddNewConsent,
	onToggleModal
}) => {
	const state = window.history.state as stateType

	const { pageData, authUser, language } = useContext(AppStateContext)
	// const [isPaymentSuccessfull, setIsPaymentSuccessfull] = useState<
	// 	boolean | null
	// >(null)
	// const [paymentMessageCode, setPaymentMessageCode] = useState<string>()
	const [request, setRequest] = useState<Request>(requestInfo)

	// const [isInProgress, setIsInProgress] = useState<boolean>(false)
	const [requestRepere, setRequestRepere] = useState<PROGRESS_REPORT | null>(
		null
	)
	const [dossiersRaw, setDossiersRaw] = useState<
		DOSSIER_FORM[] | DOSSIER_FORM | null
	>(null)
	const [documentsEnvoyes, setDocumentsEnvoyes] = useState<
		DOCUMENT_ENVOYE_FORM[] | DOCUMENT_ENVOYE_FORM | null
	>(null)

	const [isLoading, setIsLoading] = useState<boolean>(true)

	const fetchProgressReport = async (): Promise<
		PROGRESS_REPORT | undefined
	> => {
		if (!authUser) return undefined
		
		try {
			setIsLoading(true)
			const repereIntegrationRepository = new RepereIntegrationRepository()

			const progressReportData =
				await repereIntegrationRepository.getProgressReport(
					request.code,
					request.id
				)

			setRequestRepere(progressReportData)
			setIsLoading(false)
			return progressReportData
		} catch (error) {
			onToggleModal(MODAL.ERROR)
			setIsLoading(false)
			throw new Error(
				"Erreur lors de la récupération de l'état d'avancement: " + error
			)
		} finally {
			setIsLoading(false)
		}
	}

	const handleRefreshRepere = async (): Promise<void> => {
		try {
			await fetchProgressReport()
		} catch (err) {
			console.error('Erreur lors du rafraîchissement du progress report', err)
		}
	}

	useEffect(() => {
		if (request.id) fetchProgressReport()
	}, [])

	useEffect(() => {
		const source = requestRepere
		setDossiersRaw(
			requestRepere?.REQUETE?.REQUETE_TYPE?.DOSSIER?.DOSSIER_TYPE ?? null
		)
		setDocumentsEnvoyes(
			source?.REQUETE?.REQUETE_TYPE?.DOC_DEM?.DOC_DEM_TYPE ?? null
		)
	}, [requestRepere])

	// Mocked data for development and testing purposes
	// To be removed when connected to the real API

	// initialisation des dossiers MOCK
	//const DOSSIERS_RAW = REQUETE.REQUETE_TYPE?.DOSSIER?.DOSSIER_TYPE

	//const DOSSIERS: DOSSIER_FORM[] =
	//	DOSSIERS_RAW == null || DOSSIERS_RAW == undefined
	//		? []
	//		: Array.isArray(DOSSIERS_RAW)
	//		? DOSSIERS_RAW
	//		: [DOSSIERS_RAW]

	const DOSSIERS: DOSSIER_FORM[] =
		dossiersRaw == null || dossiersRaw == undefined
			? []
			: Array.isArray(dossiersRaw)
			? dossiersRaw
			: [dossiersRaw]

	// initialisation des documents envoyés
	const DOCUMENTS_ENVOYES: DOCUMENT_ENVOYE_FORM[] = (documentsEnvoyes ??
		[]) as any

	// initialisation de l'onglet actif
	const [activeTab, setActiveTab] = useState<string>(DOSSIERS[0]?.NO_SEQ || '1')

	if (isLoading) {
		return <RequestLoader />
	}

	return (
		<>
			{/* Barre des onglets */}
			{DOSSIERS && DOSSIERS?.length >= 1 && (
				<div className={pageUtils.classes.buttonWrapper}>
					{DOSSIERS?.map((dossier: DOSSIER_FORM, index) => (
						<button
							key={dossier?.NO_SEQ}
							onClick={() => setActiveTab(dossier?.NO_SEQ)}
							className={joinClasses([
								pageUtils.classes.buttonTab,
								activeTab === dossier?.NO_SEQ ? 'active' : ''
							])}
						>
							<img
								src={permisUrbIcon}
								alt=""
								className={
									activeTab === dossier?.NO_SEQ
										? pageUtils.classes.blueFilter
										: pageUtils.classes.greyFilter
								}
							/>
							{dossier?.NO_DOSSIER}
						</button>
					))}
				</div>
			)}

			<div className={pageUtils.classes.sectionViewer}>
				{/* Contenu des onglets par dossier */}
				<DossierViewer
					activeTab={activeTab}
					dossier={DOSSIERS?.find((dossier) => dossier?.NO_SEQ === activeTab)}
					multiDossier={DOSSIERS.length > 1}
					requeteDateRecu={
						requestRepere?.REQUETE?.REQUETE_TYPE
							? requestRepere.REQUETE.REQUETE_TYPE.REQUETE_DATE_RECU
							: '-'
					}
					requeteStatut={
						requestRepere?.REQUETE?.REQUETE_TYPE
							? requestRepere.REQUETE.REQUETE_TYPE.REQUETE_STATUT
							: undefined
					}
					isPrincipal={activeTab === '1'}
					onRefreshRepere={handleRefreshRepere}
					documentsEnvoyes={DOCUMENTS_ENVOYES}
					// *********
					request={request}
					isModalOpen={isModalOpen}
					consentList={consentList}
					consentClassWrapper={consentClassWrapper}
					onAddNewConsent={onAddNewConsent}
					onCloseModal={onCloseModal}
					onToggleModal={onToggleModal}
					onInformationAdded={onInformationAdded}
				/>
			</div>
		</>
	)
}

export default TNUrbanRequestDetails
